import axios from 'axios';

import config from '../../../../config/config';

const MainUrl = 'api/reports';

export const getSRRawDataReports = () =>
  axios.get(`${MainUrl}/personMembership`, {
    baseURL: config.securityResponseApi.baseUrl,
    headers: { accept: 'text/csv' },
  });
